const SEND_URL = 'https://metrika.mos.ru/hitcounter';
const SEND_URL_PREPROD = 'https://metrika.mos.ru/pprod/hitcounter';
const SEND_URL_CONTOUR = 'https://metrika.sm-soft.ru/hitcounter';

const formIds = {
  appeal: '040202',
  notCorrect: '040203'
};
const orgId = 'mosobr';

const HOME_DOMAIN = 'mos.ru';

/**
 *
 * @param form Форма - апелляция (appeal) или несоответствие бланков (notCorrect)
 * @param type Тип события
 * @param subType Подтип события
 */
const sendCMAStats = ({ form = 'appeal', type, subtype }) => {
  if (!form || !type || !subtype) {
    return Promise.reject(new Error('CMA: Не хватает параметров.'));
  }

  let sendURL = SEND_URL;

  if (window.location.hostname === 'newmos.mos.ru') {
    sendURL = SEND_URL_PREPROD;
  } else if (
    window.location.hostname === 'localhost' ||
    window.location.hostname.match(/\w+-tech.mos.ru/)
  ) {
    sendURL = SEND_URL_CONTOUR;
  }

  if (!formIds[form]) {
    throw new Error('CMA: Неправильная форма апелляции');
  }

  const eventObject = {
    timestamp: Math.floor(Date.now() / 1000),
    group: `${orgId}_${formIds[form]}`,
    type,
    subtype,
    origin: {
      url: window.location.href,
      org_id: orgId,
      form_id: formIds[form],
      code: 'mos'
    }
  };
  const body = `payload=${encodeURIComponent(JSON.stringify(eventObject))}`;

  const getFetchConfig = () => {
    const isHomeService = sendURL.includes(HOME_DOMAIN);
    return isHomeService ? { credentials: 'include' } : {};
  };

  return fetch(sendURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body,
    ...getFetchConfig()
  });
};

export const sendCMAAppealStart = () =>
  sendCMAStats({
    form: 'appeal',
    type: 'formcontroller',
    subtype: 'start'
  });

export const sendCMANotCorrectStart = () =>
  sendCMAStats({
    form: 'notCorrect',
    type: 'formcontroller',
    subtype: 'start'
  });

export const sendCMAFormStepChange = ({ form }) =>
  sendCMAStats({
    form,
    type: 'step',
    subtype: 'change'
  });

export const sendCMAAppealFinish = () =>
  sendCMAStats({
    form: 'appeal',
    type: 'step',
    subtype: 'final'
  });

export const sendCMANotCorrectFinish = () =>
  sendCMAStats({
    form: 'notCorrect',
    type: 'step',
    subtype: 'final'
  });

export const sendCMAAppealTechError = ({ stage = 'start' }) =>
  sendCMAStats({
    form: 'appeal',
    type: stage,
    subtype: 'error_tech'
  });

export const sendCMAAppealBusinessError = ({ stage = 'start' }) =>
  sendCMAStats({
    form: 'appeal',
    type: stage,
    subtype: 'error_biz'
  });

export const sendCMANotCorrectTechError = ({ stage = 'start' }) =>
  sendCMAStats({
    form: 'notCorrect',
    type: stage,
    subtype: 'error_tech'
  });

export const sendCMANotCorrectBusinessError = ({ stage = 'start' }) =>
  sendCMAStats({
    form: 'notCorrect',
    type: stage,
    subtype: 'error_biz'
  });
